module.exports = __webpack_public_path__ + "static/media/激光切割动力小车.490e300c.png";